// extracted by css-extract-rspack-plugin
export default {"sideSheetWrapper":"W5_JV5aAJbQlCmd5"};